export default __webpack_public_path__ + "static/media/icono-reportar-comercial.ac40d49c.svg";